const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Shape-1",
    serifId: "Shape 1",
    transform: "matrix(1.15789,0,0,1.16667,-1430.18,-457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1251.5,409.887C1252.84,409.883 1253.93,408.767 1253.93,407.393L1253.93,402.332C1253.93,402.023 1254.18,401.775 1254.48,401.775C1254.78,401.775 1255.02,402.027 1255.02,402.332L1255.02,407.393C1255.02,409.38 1253.44,411 1251.5,411L1239.55,411C1237.61,411 1236.02,409.384 1236.02,407.393L1236.02,402.249C1236.02,401.94 1236.27,401.693 1236.57,401.693C1236.87,401.693 1237.11,401.94 1237.11,402.249L1237.11,407.393C1237.11,408.766 1238.2,409.887 1239.55,409.887L1251.5,409.887ZM1245.14,406.581C1245.25,406.689 1245.39,406.746 1245.52,406.746C1245.66,406.746 1245.8,406.693 1245.91,406.581L1249.37,403.045C1249.58,402.826 1249.58,402.476 1249.37,402.258C1249.15,402.039 1248.81,402.039 1248.6,402.258L1246.07,404.846L1246.07,393.556C1246.07,393.247 1245.83,393 1245.52,393C1245.22,393 1244.98,393.247 1244.98,393.556L1244.98,404.846L1242.45,402.258C1242.23,402.039 1241.89,402.039 1241.68,402.258C1241.46,402.476 1241.46,402.826 1241.68,403.045L1245.14,406.581Z",
    style: {
      fill: "#666666"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9f612cdd860b9ce78a0a2f53eeabe1c5.svg";
export { ForwardRef as ReactComponent };